import "./Logo.css";

/**
 * Renders the official Devory mark (public/devory-mark.png, derived from the
 * brand source maintained in devory-platform/design_assets — see
 * docs/BRAND_ASSET_REGISTER.md) next to the wordmark. The mark is decorative
 * here since the adjacent text already names the product for assistive tech.
 */
export function Logo({ size = 28 }: { size?: number }) {
  return (
    <span className="devory-logo">
      <img src="/devory-mark.png" alt="" width={size} height={size} aria-hidden="true" />
      <span className="devory-logo-word">Devory</span>
    </span>
  );
}
